import { render, staticRenderFns } from "./GroupSentMessage.vue?vue&type=template&id=3f94f4d6&scoped=true"
import script from "./GroupSentMessage.vue?vue&type=script&lang=js"
export * from "./GroupSentMessage.vue?vue&type=script&lang=js"
import style0 from "./GroupSentMessage.vue?vue&type=style&index=0&id=3f94f4d6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f94f4d6",
  null
  
)

export default component.exports